<template>
  <ul :class="['m-search-result-list', `-layout-${layout}`]">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'SearchResultCard',
  props: {
    layout: {
      type: String,
      default: 'detailed'
    }
  }
}
</script>

<style lang="less">
@import (reference) "./../../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-search-result-list.less";
</style>
